<template>
  <div>
    <!-- 自身模块 -->
    <div class="banner self-banner">
      <!-- <div class="banner-title">驾驶证</div>
      <div class="banner-introduce">
        功能介绍
      </div> -->
      <div class="banner-content">
        <div class="inner">
          <div class="ocr">
            <div class="left card-left" v-loading="comPairloading">
              <div class="tab-content">
                <input
                  v-model="first_form.personalName"
                  type="text"
                  placeholder="姓名"
                />
                <input
                  v-model="first_form.identityCardNo"
                  type="text"
                  placeholder="身份证号"
                />
                <span class="sub-btn" @click="firstSub">提交</span>
              </div>
            </div>
            <div class="right card-right sub-right">
              <el-collapse v-model="activeNames" accordion>
                <el-collapse-item name="2">
                  <template slot="title">
                    <div class="title">
                      <img :src="require('../../assets/img/tb2.png')" alt="" />
                      <span>Response JSON</span>
                    </div>
                  </template>
                  <ocrResult :resp_data="resp_data"></ocrResult>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="" :visible.sync="dialogVisible" width="250px">
      <el-input
        v-model="v_code"
        placeholder="验证码"
        style="width: 100px"
      ></el-input>
      <div
        class="v_img"
        style="
          width: 100px;
          height: 40px;
          display: inline-block;
          vertical-align: top;
        "
        @click="getVerCode"
      >
        <img
          :src="code.image"
          alt="验证码"
          style="height: 40px; max-width: 110px"
        />
      </div>
      <div style="font-size: 12px; color: #1a6ad1; margin-top: 8px">
        您已超过使用次数，请输入验证码后继续使用。
      </div>

      <span slot="footer" class="dialog-footer">
        <span class="code_veri" @click="code_sub()">确认</span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ocrLeft from "../../components/ocr-left.vue";
import ocrResult from "../../components/ocr-result.vue";
import ocrNoResult from "../../components/ocr-no-result.vue";
import qs from "qs";

export default {
  components: {
    ocrLeft,
    ocrResult,
    ocrNoResult,
  },
  data() {
    return {
      firstKey: 0,
      secondKey: 1,
      activeNames: ["2"],
      tables: [],
      resp_data: "",
      coordinate: [],
      preview_img: "",
      activeName: "first",
      first_form: {
        personalName: "",
        identityCardNo: "",
      },
      second_form: {
        appKey: "",
        appSecret: "",
        bankCardNo: "",
        personalName: "",
        identityCardNo: "",
        phoneNo: "",
      },
      comPairloading: false,
      dialogVisible: false,
      code: {
        key: "",
        image: "",
      },
      need_code: false, //需要输入验证码
      v_code: "",
    };
  },
  computed: {
    ocrUrl() {
      return this.$menuData[6].childs.verifyId.ocr_url;
    },
  },
  methods: {
    code_sub() {
      if (this.v_code == "") {
        this.$message.error("请输入验证码！");
        return;
      }
      this.firstSub();
      this.dialogVisible = false;
    },
    getVerCode() {
      this.$axios
        .get(this.$ocrDomainNames + "api/captcha/generateCaptcha")
        .then((resp) => {
          if (resp.status === 200 && resp.data && resp.data.success) {
            this.code.key = resp.data.data.key;
            this.code.image = resp.data.data.image;
          } else {
            this.$message.error(resp.msg);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$message.error("获取验证码失败");
        });
    },
    firstSub() {
      this.comPairloading = true;
      let headers = this.need_code
        ? {
            "Captcha-Key": this.code.key,
            "Captcha-Code": this.v_code,
            "Content-Type": "application/x-www-form-urlencoded",
          }
        : {
            "Content-Type": "application/x-www-form-urlencoded",
          };
      this.$axios
        .post(
          this.$dataDomainNames + this.ocrUrl,
          qs.stringify(this.first_form),
          {
            headers: headers
          }
        )
        .then((resp) => {
          this.comPairloading = false;
          this.need_code = false;
          if (resp.data && resp.data.code === 201) {
            this.dialogVisible = true;
            this.v_code = "";
            this.dialogVisible = true;
            this.need_code = true;
            this.getVerCode();
            return;
          }
          this.resp_data = resp.data;
        })
        .catch((error) => {
          this.comPairloading = false;
          window.console.log(error);
        });
    },
    getOcrResult(resp) {
      this.buildViewData(resp);
    },
  },
  mounted() {},
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/face/verifyId.vue